import { ScreenElementFragment } from '@/generated/graphql';

/**
 * In many cases, if a style is set to the same value on an engagement as default,
 * then updating the default style should also update the engagement style.
 */
export function createStyleUpdate(
  fieldUpdates: Record<string, string>,
  element: ScreenElementFragment,
  engagement: boolean,
) {
  if (engagement) {
    return {
      ...element,
      engagementStyles: {
        ...element.engagementStyles,
        ...fieldUpdates,
      },
    };
  }

  const updates = {
    ...element,
    defaultStyles: {
      ...element.defaultStyles,
      ...fieldUpdates,
    },
  };

  // if every field in fieldUpdates is the same as the default styles,
  // then we can just update the engagement styles
  if (
    Object.keys(fieldUpdates).every((key) => {
      return element.engagementStyles[key] === element.defaultStyles[key];
    })
  ) {
    updates.engagementStyles = {
      ...element.engagementStyles,
      ...fieldUpdates,
    };
  }

  return updates;
}
